import { useEffect, useState } from "react";

import { UPDATE_READY } from "../lib/swUpdate";

// Remembered from module load, like the install prompt: the announcement is an event, and a
// screen that mounts after it fired would otherwise never hear that a build is waiting.
let announced = false;
if (typeof window !== "undefined") window.addEventListener(UPDATE_READY, () => (announced = true));

/**
 * True once a waiting build has been announced. Shared by the update Notice on Today and the
 * Version row on Account & data. A build that arrives while Kaya is open is only offered: a reload
 * mid-session would lose a running timer, and the app is usable while a day behind. One already
 * waiting when Kaya opens is applied at launch instead (main.tsx::swapAtLaunch).
 */
export function useUpdateReady(): boolean {
  const [ready, setReady] = useState(announced);
  useEffect(() => {
    const on = () => setReady(true);
    window.addEventListener(UPDATE_READY, on);
    return () => window.removeEventListener(UPDATE_READY, on);
  }, []);
  return ready;
}
